import { SegmentedControl } from '@creditornot/cb-segmented-control';
import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { MOBILE_BREAKPOINT } from 'common/hooks/useIsMobile';

import { VenuePayoutReportType } from './types';
type VenuePayoutReportTypeSwitchProps = {
  venuePayoutReportType: VenuePayoutReportType;
  setVenuePayoutReportType: (value: VenuePayoutReportType) => void;
};

const VenuePayoutReportTypeSwitchContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 24px;
  gap: 16px;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    flex-direction: column;
    gap: 24px;
  }
`;

export const VenuePayoutReportTypeSwitch = ({
  venuePayoutReportType,
  setVenuePayoutReportType,
}: VenuePayoutReportTypeSwitchProps) => {
  const { formatMessage } = useIntl();
  return (
    <VenuePayoutReportTypeSwitchContainer>
      <SegmentedControl<VenuePayoutReportType>
        options={[
          {
            value: 'reports',
            label: formatMessage({ id: 'navigation.payout-reports' }),
          },
          {
            value: 'invoices',
            label: formatMessage({ id: 'payout-reports.invoices' }),
          },
        ]}
        onChange={value => setVenuePayoutReportType(value)}
        value={venuePayoutReportType}
      />
    </VenuePayoutReportTypeSwitchContainer>
  );
};
